import { AllLevelRestrictionStoreStatic, RestrictionStoreStatic } from "./RestrictionStoreStatic";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const RestrictionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const RestrictionStore: RestrictionStoreStatic = new RestrictionStoreStatic();


export const AllLevelRestrictionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const AllLevelRestrictionStore: AllLevelRestrictionStoreStatic = new AllLevelRestrictionStoreStatic();